
class MasterService {
  private static instance: MasterService;
  private constructor() {
  }

  public static getInstance(): MasterService {
    if (!MasterService.instance) {
        MasterService.instance = new MasterService();
    }
    return MasterService.instance;
  }

  public transformToJson =  (data: string) => { 
     return JSON.parse(data);
  };


  public Months: any = {
    Month1: "Jan",
    Month2: "Feb",
    Month3: "Mar",
    Month4: "Apr",
    Month5: "May",
    Month6: "Jun",
    Month7: "Jul",
    Month8: "Aug",
    Month9: "Sep",
    Month10: "Oct",
    Month11: "Nov",
    Month12: "Dec"
  
  };

  
}

export default MasterService;







